import { ReactComponent as LogoFR } from '../../../assets/IHU-logo-color-fr.svg'
import { ReactComponent as LogoEN } from '../../../assets/IHU-logo-color-en.svg'
import style from './style.module.scss'
import i18next from 'i18next'

const getLanguage = () => i18next.language || window.localStorage.i18nextLng

const LogoMainHeader = () => {
    const currentLang = getLanguage()
    const LogoTag = currentLang === 'fr' ? LogoFR : LogoEN

    return (
        <a href={currentLang === 'fr' ? '/' : '/en'} className={style.logo}>
            <LogoTag alt={'IHU Liryc'} />
        </a>
    )
}

export default LogoMainHeader
